<template>
  <div class="Shipment">
    <div class="page-title">{{ title }}</div>
    <ATable
      ref="table"
      max-height="750px"
      hide-button-insert
      v-loading="loading"
      buttons-width="200px"
      :placeholder="placeholder"
      :search_field="search_field"
      :data="items"
      hide-pagination
      border
      @selection-change="handleSelectionChange"
    >
      <div slot="search">
        <div class="inline">
          <APeriodSelector
            ref="period"
            value="1w"
            @change="handleChangePeriod"
          />
        </div>
        <div class="inline">
          <el-button
            type="primary"
            size="mini"
            round
            v-shortkey="['f5']"
            @shortkey.native="handleClickSearch"
            @click="handleClickSearch"
            >{{ $t("button.search") }}(F5)</el-button
          >
        </div>
      </div>
      <el-table-column
        type="selection"
        align="center"
        :width="$width.selection"
      />
      <el-table-column
        type="index"
        label="No"
        :index="handleIndex"
        :width="$width.index"
        align="center"
      />
      <el-table-column prop="code" label="수주번호" width="100" />
      <el-table-column
        prop="customer_name"
        :label="$t('lang.customer_name')"
        show-overflow-tooltip
      />
      <el-table-column
        prop="product_name"
        label="품목"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column
        prop="destination"
        :label="$t('lang.destination')"
        show-overflow-tooltip
      />
      <el-table-column
        prop="delivery_date"
        :label="$t('lang.delivery_date')"
        :width="$width.date"
      />
      <el-table-column
        prop="customer_tel"
        :label="$t('lang.phone_number')"
        width="110"
      />
      <el-table-column
        prop="delivery_way_flag"
        :label="$t('lang.shipping_mode')"
        width="90"
      >
        <template slot-scope="scope">{{
          resolveDeliveryWayFlag(scope.row.delivery_way_flag)
        }}</template>
      </el-table-column>
      <el-table-column :label="$t('lang.state')" align="center" width="60">
        <template slot-scope="scope">{{
          resolveShipmentFlag(scope.row.shipment_flag)
        }}</template>
      </el-table-column>
      <div slot="buttons">
        <el-button
          type="primary"
          :disabled="selection.length < 1 || !has_grant_write"
          @click="handleClickShipment"
          >{{ $t("button.manual_shipment") }}</el-button
        >
        <el-button
          type="danger"
          :disabled="selection.length < 1 || !has_grant_write"
          @click="handleClickCancel"
          >{{ $t("button.cancel_shipment") }}</el-button
        >
      </div>
    </ATable>
    <div class="row-splitter" style="width: 300px;">
      <el-input
        ref="barcode"
        placeholder="Scan Barcode"
        v-model="barcode"
        :disabled="!has_grant_write"
        @keyup.native.enter="handleEnterBarcode"
      >
        <template slot="prepend">출하</template>
      </el-input>
    </div>
  </div>
</template>
<script>
import { authority_level } from "@/common/mixins/authority_level";

export default {
  name: "Shipment",
  mixins: [authority_level],
  data() {
    return {
      title: this.$t("title.production_shipment"),
      search_field: ["code", "customer_name", "product_name", "destination"],
      placeholder: "수주번호, 거래처, 품목, 도착지",
      loading: false,
      items: [],
      period: {},
      selection: [],
      barcode: "",
    };
  },
  computed: {
    has_grant_write() {
      return this.isWriteLevel("production_shipment");
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.barcode.focus();
      this.loadData();
    });
  },
  methods: {
    loadData() {
      this.loading = true;
      this.api.listContractShipment(this.period).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        let items = res.data;
        items.forEach((item) => {
          item.product_name = this.resolveProductName(item);
        });
        this.items = items;
      });
    },
    doShipment() {
      let params = [];
      this.loading = true;
      this.selection.map((s) => params.push(s.id));
      this.api.updateContractShipmentFinish(params).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.loadData();
      });
    },
    doCancel() {
      let params = [];
      this.loading = true;
      this.selection.map((s) => params.push(s.id));
      this.api.updateContractShipmentCancel(params).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.loadData();
      });
    },
    resolveDeliveryWayFlag(val) {
      let flag = this.system.options.delivery_way_flag.find(
        (f) => f.value === val
      );
      if (!flag) return "";
      return flag.label;
    },
    resolveShipmentFlag(val) {
      if (val === "Y") {
        return "출하";
      } else {
        return "진행";
      }
    },
    resolveProductName(row) {
      if (row.details.length > 1) {
        return (
          row.details[0].product_name + " 외 " + (row.details.length - 1) + "건"
        );
      } else if (row.details.length === 1) {
        return row.details[0].product_name;
      } else {
        return "";
      }
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handleClickShipment() {
      this.util.confirm(this, this.title, "출하하시겠습니까?", this.doShipment);
    },
    handleClickCancel() {
      this.util.confirm(this, this.title, "취소하시겠습니까?", this.doCancel);
    },
    handleEnterBarcode() {
      if (!this.has_grant_write) {
        return;
      }
      let barcode = this.barcode;
      this.barcode = "";
      let item = this.items.find((t) => t.code === barcode);
      if (!item) {
        return;
      }
      this.api.updateContractShipmentFinishById(item).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        let data = this.util.clone(res.data);
        data.product_name = this.resolveProductName(data);
        let index = this.items.findIndex((t) => t.id === data.id);
        if (index < 0) {
          return;
        }
        this.items.splice(index, 1, data);
      });
    },
  },
};
</script>
